import styled from 'styled-components';

export const Box = styled.div`
  position: fixed;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;

  opacity: 0.5;
  filter: alpha(opacity=50);
  background-color: #fff;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 999999;
  img {
    margin-bottom: 10px;
    border-radius: 50%;
  }
`;
